import { queryBuilder } from '@inpart-io/devtools-iap';
import { GET_BY_ID_LIST, RECEIVE_DATA_OBJECTS, RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type ILeadTag, leadTagsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { LEAD_TAG_MODULE } from './index';
import { ADD_TAG_FOR_LEAD, RECEIVE_TAG_FOR_LEAD, REMOVE_TAG_FOR_LEAD } from './mutations';

export const ADD_LEADS_TO_TAG = 'addLeadsToTag';
export const REMOVE_LEADS_FROM_TAG = 'removeLeadsFromTag';
export const RETRIEVE_TAGS_FOR_LEAD_LIST = 'retrieveTagsForLeadList';
export const MERGE_LEAD_TAGS = 'mergeLeadTags';

export const actions: ActionTree<ILeadTag, unknown> = {
    async [ADD_LEADS_TO_TAG](context, { tagId, leadIds, properties }: { tagId: number; leadIds: number[]; properties?: string }) {
        const result: ILeadTag = await leadTagsManager.addLeadsToTag(tagId, leadIds, { properties });
        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        context.commit(ADD_TAG_FOR_LEAD, { leadIds, tag: result });
    },

    async [REMOVE_LEADS_FROM_TAG](context, { tagId, leadIds, properties }: { tagId: number; leadIds: number[]; properties?: string }) {
        const result: ILeadTag = await leadTagsManager.removeLeadsFromTag(tagId, leadIds, { properties });
        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        context.commit(REMOVE_TAG_FOR_LEAD, { leadIds, tagId });
    },

    async [RETRIEVE_TAGS_FOR_LEAD_LIST](context, { leadIds, properties }: { leadIds: number[]; properties?: string }) {
        const query = queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('onLeads', leadIds)), undefined, undefined, [
            {
                attribute: 'label',
                direction: 'ASC'
            }
        ]);

        return context.dispatch(RETRIEVE_BY_QUERY, { query, properties }).then((tagIds) => {
            const leadTagList = context.rootGetters[`${LEAD_TAG_MODULE}/${GET_BY_ID_LIST}`](tagIds);
            leadIds.forEach((leadId) => {
                context.commit(RECEIVE_TAG_FOR_LEAD, {
                    leadId,
                    tagList: leadTagList
                        .filter((tag: ILeadTag) => {
                            return tag.onLeads?.includes(leadId);
                        })
                        .map((tag: ILeadTag) => {
                            return tag.dobjId;
                        })
                });
            });
        });
    },
    async [MERGE_LEAD_TAGS](context, { dobjIds, target, properties }: { dobjIds: number[]; target?: ILeadTag; properties?: string }): Promise<ILeadTag> {
        if (target.dobjId === undefined) {
            target.dobjId = dobjIds.shift();
        }
        await leadTagsManager.merge(dobjIds, target, properties);
        return target;
    }
};
